module.exports = __webpack_public_path__ + "img/about-bg.14735b11.png";